import { Stack, Typography } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { DividerWithLabel, ICONS, LinkUnstyled } from '@hcr/ui'

import { Path } from '../../../../../models/navigation'
import { Icon, Link } from '../components'

export const Ownership: FC = () => {
  const { t } = useTranslation()

  return (
    <Stack tabIndex={-1} component='li'>
      <DividerWithLabel component='h2'>{t('account.ownership')}</DividerWithLabel>
      <Link component={LinkUnstyled as React.ElementType} to={Path.Owner} $disableBorderBottom={true}>
        <Typography variant='labelM'>{t('account.holdings')}</Typography>
        <Icon icon={ICONS.farChevronRight} />
      </Link>
    </Stack>
  )
}
